import {
  and,
  ControlProps,
  RankedTester,
  rankWith,
  schemaMatches,
  Tester,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";
import dayjs from "dayjs";
import { HHNConstants } from "@home-health-notify/domain";
import isEmpty from "lodash/isEmpty";

const DateViewRenderer = ({ data, label }: ControlProps) => {
  const visitDate = data
    ? dayjs(data).format(HHNConstants.DATE_VIEW_FORMAT)
    : "N/A";
  return (
    <FormDetailWrapper data-testid="form-content-item">
      <FormDetailItem>{label} :</FormDetailItem>
      <FormDetailValue>{visitDate}</FormDetailValue>
    </FormDetailWrapper>
  );
};

const formatIs = (expectedFormat: string): Tester =>
  schemaMatches(schema => !isEmpty(schema) && schema.format === expectedFormat);

const isDateControl = and(uiTypeIs("Control"), formatIs("date"));

export const dateViewTester: RankedTester = rankWith(7, isDateControl);

export default withJsonFormsControlProps(DateViewRenderer);
